<div class="base-container">
  @let langSignalValue = languageService.langSignal();
  <div class="panel">
    <!-- Date Panel-->
    <mat-form-field appearance="fill" (click)="picker.open()">
      <mat-label>{{
        'PRODUCT.SMW.ARCHIVE.SELECT_TIME_RANGE' | translate
      }}</mat-label>
      <mat-date-range-input
        [formGroup]="dateRange"
        [rangePicker]="picker"
        [dateFilter]="dateFilter">
        <input matStartDate formControlName="start" placeholder="Startdatum" />
        <input matEndDate formControlName="end" placeholder="Enddatum" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker">
        <fa-icon
          matDatepickerToggleIcon
          [icon]="['far', 'calendar-alt']"
          transform="up-4"
          size="lg"></fa-icon>
      </mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      @if (startHasMatError()) {
        <mat-error>Invalid start date</mat-error>
      }
      @if (endHasMatError()) {
        <mat-error>Invalid end date</mat-error>
      }
    </mat-form-field>

    <!-- Button Request Data -->
    <button
      mat-raised-button
      color="primary"
      class="button-query"
      (click)="onQueryData()"
      [disabled]="dateRangeInvalid()">
      <fa-icon [icon]="['far', 'th']"></fa-icon> &nbsp;
      {{ 'PRODUCT.SMW.ARCHIVE.QUERY_DATA' | translate }}
    </button>
  </div>

  <div class="flex-flow-wrapper-archive">
    @let noDataHasBeenRequestedValue = noDataHasBeenRequested();
    @if (noDataHasBeenRequestedValue) {
      <!-- NO DATA REQUESTED -->
      <mat-card appearance="outlined" class="archive-card--big">
        <mat-card-content>
          <div class="archive-card__message">
            {{ 'PRODUCT.SMW.ARCHIVE.CLICK_START_END_DATE' | translate }}
          </div>
        </mat-card-content>
      </mat-card>
    }

    @let warningCardHasContentValue = warningCardHasContent();
    @let eopCardHasContentValue = eopCardHasContent();
    @let eppCardHasContentValue = eppCardHasContent();
    @let egpCardHasContentValue = egpCardHasContent();
    @let egpSummerCardHasContentValue = egpSummerCardHasContent();
    @let filteredWarningsValue = filteredWarnings();
    @let selectedWarningAreaIdValue = selectedWarningAreaId();
    @if (
      !warningCardHasContentValue &&
      !egpCardHasContentValue &&
      !egpSummerCardHasContentValue &&
      !eopCardHasContentValue &&
      !eppCardHasContentValue &&
      !noDataHasBeenRequestedValue
    ) {
      <!-- NO DATA FOUND FOR TIME RANGE -->

      <mat-card appearance="outlined" class="archive-card--big">
        <mat-card-content>
          <div class="archive-card__message">
            {{ 'PRODUCT.ARCHIVE.NO_DATA_IN_TIME_RANGE' | translate }}
          </div>
        </mat-card-content>
      </mat-card>
    }

    @if (warningCardHasContentValue) {
      <!--WARNING CARD-->
      <mat-card appearance="outlined" class="archive-card--big">
        <mat-card-header>
          <fa-icon
            mat-card-avatar
            [icon]="['far', 'exclamation-triangle']"
            size="2x"></fa-icon>
          <mat-card-title>
            <div class="archive-card-title">
              {{ 'PRODUCT.WARNING.TITLE' | translate }}
            </div>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <!-- CSV DOWNLOAD  (hides automatically when filteredWarnings doesnt hold any data for areaId)-->
          <a
            [ngStyle]="{
              visibility:
                filteredWarningsValue[selectedWarningAreaIdValue].length > 0
                  ? 'visible'
                  : 'hidden',
            }"
            csvLink
            mat-button
            class="archive-card__download-btn"
            matTooltip="{{ 'PRODUCT.ARCHIVE.DOWNLOAD_CSVFILE' | translate }}"
            [data]="csvData()"
            [headers]="csvHeader()"
            [delimiter]="';'"
            [filename]="csvFileName()">
            <fa-icon [icon]="['far', 'download']" size="lg"></fa-icon>
          </a>

          @if (warningCardHasContentValue) {
            <div class="archive-card__selectWrapper">
              <mat-form-field class="archive-card__station-select--large">
                <mat-select
                  [(value)]="selectedWarningAreaId"
                  (selectionChange)="onChangeWarningAreaId($event)">
                  @for (areaId of filteredWarningsValue | key; track $index) {
                    <mat-option [value]="areaId">
                      {{ warningStationNames()[areaId] }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (
              filteredWarningsValue &&
              filteredWarningsValue[selectedWarningAreaIdValue].length > 0
            ) {
              <!-- EGW WARNINGS -->
              <mat-list class="warnings-matrix-list">
                @for (
                  singleWarningOfArea of paginatorDataWarnings();
                  track $index
                ) {
                  <!-- Warnungs-Zeile mit dynamischem Farbmodifikator -->
                  <mat-list-item
                    class="single-warning-item-row warn-border-{{
                      singleWarningOfArea['color']
                    }}">
                    <div class="warning-row-grid-container">
                      <!-- Spalte 1: Status-Symbol (Leuchtend im Darkmode) -->
                      <div class="warning-cell-icon" matListItemIcon>
                        <fa-icon
                          [icon]="['far', singleWarningOfArea['symbol']]"
                          [ngClass]="
                            'warn-color-' + singleWarningOfArea['color']
                          "
                          size="2x"
                          class="status-fa-icon-glow">
                        </fa-icon>
                      </div>

                      <!-- Spalte 2: Datum & Uhrzeit (Kompakter Block) -->
                      <div class="warning-cell-meta-date">
                        <fa-icon
                          [icon]="['far', 'clock']"
                          class="meta-date-clock-icon"></fa-icon>
                        <div class="date-time-string">
                          <span class="date-part">
                            {{
                              singleWarningOfArea['dtg']
                                | datex
                                  : 'dd DD.MM.YY'
                                  : undefined
                                  : langSignalValue
                            }}
                          </span>
                          <span class="time-part">
                            {{
                              singleWarningOfArea['dtg']
                                | datex: 'HH:mm' : undefined : langSignalValue
                            }}
                            <small class="clock-label">{{
                              'DATETIME.CLOCK' | translate
                            }}</small>
                          </span>
                        </div>
                      </div>

                      <!-- Spalte 3: Der gesplittete Warnungstext (Strukturiert aufbereitet) -->
                      <div class="warning-cell-text-payload">
                        @for (
                          warnSplittedByDate of singleWarningOfArea[
                            'message'
                          ].split('\,,');
                          track $index;
                          let firstBlock = $first
                        ) {
                          <div
                            class="warning-text-paragraph-group"
                            [class.primary-alert-paragraph]="firstBlock">
                            @for (
                              warnSplittedByText of warnSplittedByDate.split(
                                '\,'
                              );
                              track $index;
                              let firstLine = $first
                            ) {
                              <div
                                [ngClass]="
                                  firstLine
                                    ? 'warning-chunk-headline'
                                    : 'warning-chunk-subtext'
                                ">
                                {{ warnSplittedByText | translate }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </mat-list-item>

                  <!-- Feine Trennlinie im Glass-Look -->
                  <mat-divider class="warning-row-divider"></mat-divider>
                }
              </mat-list>
            } @else {
              <!--TEMPLATE: EGW NO WARNINGS FOR AREA-->
              <div class="archive-card__message">
                Für diese Station liegen keine Warnungen vor
              </div>
            }

            <!-- EGW PAGINATOR -->
            <mat-paginator
              [showFirstLastButtons]="true"
              [length]="
                filteredWarningsValue[selectedWarningAreaIdValue].length
              "
              [pageSize]="5"
              [pageSizeOptions]="[5, 10, 20, 50]"
              (page)="onChangePage($event)">
            </mat-paginator>
          }
        </mat-card-content>
      </mat-card>
    }

    <!-- EGP -->
    <!-- SWITCH FOR TO REACT WHEN WINTER-EGP AND SUMMER-EGP HAVE TO BE SHOWN -->
    <div class="archive-grid-container">
      @switch (true) {
        @case (egpSummerCardHasContentValue && egpCardHasContentValue) {
          <!-- SWITCHCASE: EGP + EGP-SUMMER (TABS-MODUS) -->
          <mat-card
            appearance="outlined"
            class="archive-card-item custom-archive-glass-card">
            <ng-container *ngTemplateOutlet="egpHeader"></ng-container>

            <mat-tab-group class="archive-card-tabs">
              <mat-tab label="Sommer">
                <div class="archive-tab-content-padding">
                  <ng-container
                    *ngTemplateOutlet="egpSummerContent"></ng-container>
                </div>
              </mat-tab>
              <mat-tab label="Winter">
                <div class="archive-tab-content-padding">
                  <ng-container
                    *ngTemplateOutlet="egpCardContent"></ng-container>
                </div>
              </mat-tab>
            </mat-tab-group>
          </mat-card>
        }

        @case (egpSummerCardHasContentValue && !egpCardHasContentValue) {
          <!-- SWITCHCASE: ONLY EGPSUMMER -->
          <mat-card
            appearance="outlined"
            class="archive-card-item custom-archive-glass-card">
            <ng-container *ngTemplateOutlet="egpHeader"></ng-container>

            <div class="archive-card-static-content">
              <ng-container *ngTemplateOutlet="egpSummerContent"></ng-container>
            </div>
          </mat-card>
        }

        @case (!egpSummerCardHasContentValue && egpCardHasContentValue) {
          <!-- SWITCHCASE: ONLY EGP -->
          <mat-card
            appearance="outlined"
            class="archive-card-item custom-archive-glass-card">
            <ng-container *ngTemplateOutlet="egpHeader"></ng-container>

            <div class="archive-card-static-content">
              <ng-container *ngTemplateOutlet="egpCardContent"></ng-container>
            </div>
          </mat-card>
        }
      }
      <!-- ========================================== -->
      <!-- TEMPLATE: EGP HEADER                       -->
      <!-- ========================================== -->
      <ng-template #egpHeader>
        <mat-card-header class="archive-card-header-zone">
          <div class="archive-header-title-flex">
            <fa-icon
              mat-card-avatar
              [icon]="['far', 'border-all']"
              size="lg"
              class="header-avatar-icon icon-accent--egp"></fa-icon>
            <mat-card-title class="archive-main-title">
              {{ 'PRODUCT.EGP-SUMMER.TITLE' | translate }}
            </mat-card-title>
          </div>

          <!-- ZIP DOWNLOAD BUTTON (Radar-Blau Akzentuiert) -->
          <button
            mat-icon-button
            class="btn-archive-zip-download btn-zip-accent"
            [matTooltip]="'PRODUCT.ARCHIVE.DOWNLOAD_ZIPFILE' | translate"
            (click)="onZipDownload('egpProducts')">
            <fa-icon [icon]="['far', 'download']"></fa-icon>
          </button>
        </mat-card-header>
      </ng-template>

      <!-- ========================================== -->
      <!-- TEMPLATE: EGP WINTER CARD CONTENT          -->
      <!-- ========================================== -->
      <ng-template #egpCardContent>
        @let egpDataGroupedByLocationIdValue = egpDataGroupedByLocationId();
        @let egpAreaNamesValue = egpAreaNames();

        <div class="archive-dropdown-select-row">
          <!-- EGP-STATION SELECTION -->
          <mat-form-field appearance="fill" class="archive-inline-select">
            <mat-select [(value)]="selectedEgpStationId">
              @for (
                stationId of egpDataGroupedByLocationIdValue | key;
                track $index
              ) {
                <mat-option
                  id="egpStationSelect"
                  [value]="stationId"
                  (onSelectionChange)="onStationSelect($event)">
                  {{ egpAreaNamesValue[stationId] }} ({{
                    'SAISON.WINTER' | translate
                  }})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- EGP PDF'S SCROLL-BOX -->
        <div class="archive-pdf-scroll-box">
          @for (
            singleEgpData of egpDataGroupedByLocationIdValue[
              selectedEgpStationId()
            ][selectedEgpType()];
            track $index
          ) {
            <a
              mat-button
              class="archive-pdf-download-link"
              (click)="downloadPdf(singleEgpData.path)">
              <div class="pdf-link-content">
                <fa-icon
                  [icon]="['far', 'file-pdf']"
                  class="pdf-file-icon"></fa-icon>
                <span class="pdf-link-date">
                  {{
                    singleEgpData?.dtg
                      | datex
                        : 'DD.MM. HH:mm'
                        : undefined
                        : (langSignalValue | getLocaleFromLang)
                  }}
                  <small class="pdf-clock-lbl">{{
                    'DATETIME.CLOCK' | translate
                  }}</small>
                </span>
                <span class="pdf-link-divider">–</span>
                <span class="pdf-link-station">{{
                  egpAreaNamesValue[singleEgpData?.location]
                }}</span>
              </div>
            </a>
          }
        </div>
      </ng-template>

      <!-- ========================================== -->
      <!-- TEMPLATE: EGP SUMMER CARD CONTENT          -->
      <!-- ========================================== -->
      <ng-template #egpSummerContent>
        @let egpSummerDataGroupedByLocationIdValue =
          egpSummerDataGroupedByLocationId();
        @let egpSummerAreaNamesValue = egpSummerAreaNames();

        <div class="archive-dropdown-select-row">
          <!-- EGP-SUMMER STATION SELECTION -->
          <mat-form-field appearance="fill" class="archive-inline-select">
            <mat-select [(value)]="selectedEgpSummerStationId">
              @for (
                stationId of egpSummerDataGroupedByLocationIdValue | key;
                track $index
              ) {
                <mat-option id="egpSummerStationSelect" [value]="stationId">
                  {{ egpSummerAreaNamesValue[stationId] }} ({{
                    'SAISON.SUMMER' | translate
                  }})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- EGP SUMMER PDF'S SCROLL-BOX -->
        <div class="archive-pdf-scroll-box">
          @for (
            singleEgpSummerData of egpSummerDataGroupedByLocationIdValue[
              selectedEgpSummerStationId()
            ][selectedEgpSummerType()];
            track $index
          ) {
            <a
              mat-button
              class="archive-pdf-download-link"
              (click)="downloadPdf(singleEgpSummerData.path)">
              <div class="pdf-link-content">
                <fa-icon
                  [icon]="['far', 'file-pdf']"
                  class="pdf-file-icon"></fa-icon>
                <span class="pdf-link-date">
                  {{
                    singleEgpSummerData.dtg
                      | datex
                        : 'DD.MM. HH:mm'
                        : undefined
                        : (langSignalValue | getLocaleFromLang)
                  }}
                  <small class="pdf-clock-lbl">{{
                    'DATETIME.CLOCK' | translate
                  }}</small>
                </span>
                <span class="pdf-link-divider">–</span>
                <span class="pdf-link-station">{{
                  egpSummerAreaNamesValue[singleEgpSummerData.location]
                }}</span>
              </div>
            </a>
          }
        </div>
      </ng-template>

      @if (eopCardHasContentValue) {
        <mat-card
          appearance="outlined"
          class="archive-card-item custom-archive-glass-card">
          <mat-card-header class="archive-card-header-zone">
            <div class="archive-header-title-flex">
              <fa-icon
                mat-card-avatar
                [icon]="['far', 'clouds-sun']"
                size="lg"
                class="header-avatar-icon"></fa-icon>
              <mat-card-title>{{
                'PRODUCT.EOP.TITLE' | translate
              }}</mat-card-title>
            </div>

            <!-- ZIP DOWNLOAD BUTTON (Als flacher Glass-Icon-Button) -->
            <button
              mat-icon-button
              class="btn-archive-zip-download"
              matTooltip="{{ 'PRODUCT.ARCHIVE.DOWNLOAD_ZIPFILE' | translate }}"
              (click)="onZipDownload('eopProducts')">
              <fa-icon [icon]="['far', 'download']"></fa-icon>
            </button>
          </mat-card-header>

          <mat-card-content class="archive-card-static-content">
            @let eopDataGroupedByLocationIdValue = eopDataGroupedByLocationId();
            @let selectedEopStationIdValue = selectedEopStationId();
            @let eopStationNamesValue = eopStationNames();

            <!-- Dropdown-Reihe (Nebeneinander via Flexbox) -->
            <div class="archive-dropdown-select-row">
              <!-- EOP_STATION SELECTION -->
              <mat-form-field appearance="fill" class="archive-inline-select">
                <mat-select
                  [(value)]="selectedEopStationId"
                  (selectionChange)="
                    onEopStationChange(selectedEopStationIdValue)
                  ">
                  @for (
                    stationId of eopDataGroupedByLocationIdValue | key;
                    track $index
                  ) {
                    <mat-option id="eopStationSelect" [value]="stationId">
                      {{ eopStationNamesValue[stationId] }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <!-- EOP-TYPE SELECTION -->
              <mat-form-field appearance="fill" class="archive-inline-select">
                <mat-select [(value)]="selectedEopType">
                  @for (
                    productType of eopDataGroupedByLocationIdValue[
                      selectedEopStationIdValue
                    ] | key;
                    track $index
                  ) {
                    <mat-option id="eopTypeSelect" [value]="productType">
                      {{
                        'PRODUCT.EOP.TYPE.' + eopTypesTranslate[productType]
                          | translate
                      }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- EOP PDF DOWNLOADS (Scrollbare Kiste im Glass-Look) -->
            <div class="archive-pdf-scroll-box">
              @for (
                singleEopData of eopDataGroupedByLocationIdValue[
                  selectedEopStationIdValue
                ][selectedEopType()];
                track $index
              ) {
                <a
                  mat-button
                  class="archive-pdf-download-link"
                  (click)="downloadPdf(singleEopData.path)">
                  <div class="pdf-link-content">
                    <fa-icon
                      [icon]="['far', 'file-pdf']"
                      class="pdf-file-icon"></fa-icon>
                    <span class="pdf-link-date">
                      {{
                        singleEopData.dtg
                          | datex
                            : 'DD.MM. HH:mm'
                            : undefined
                            : (langSignalValue | getLocaleFromLang)
                      }}
                      <small class="pdf-clock-lbl">{{
                        'DATETIME.CLOCK' | translate
                      }}</small>
                    </span>
                    <span class="pdf-link-divider">-</span>
                    <span class="pdf-link-station">{{
                      eopStationNamesValue[singleEopData.location]
                    }}</span>
                  </div>
                </a>
              }
            </div>
          </mat-card-content>
        </mat-card>
      }

      <!-- ========================================== -->
      <!-- KARTE 2: EPP ARCHIVE CARD                  -->
      <!-- ========================================== -->
      @if (eppCardHasContentValue) {
        <mat-card
          appearance="outlined"
          class="archive-card-item custom-archive-glass-card">
          <mat-card-header class="archive-card-header-zone">
            <div class="archive-header-title-flex">
              <fa-icon
                mat-card-avatar
                [icon]="['far', 'clouds-sun']"
                size="lg"
                class="header-avatar-icon icon-accent--epp"></fa-icon>
              <mat-card-title class="archive-main-title">
                {{ 'PRODUCT.EPP.TITLE' | translate }}
              </mat-card-title>
            </div>

            <!-- ZIP DOWNLOAD BUTTON (Radar-Blau Akzentuiert) -->
            <button
              mat-icon-button
              class="btn-archive-zip-download btn-zip-accent"
              [matTooltip]="'PRODUCT.ARCHIVE.DOWNLOAD_ZIPFILE' | translate"
              (click)="onZipDownload('eppProducts')">
              <fa-icon [icon]="['far', 'download']"></fa-icon>
            </button>
          </mat-card-header>

          <div class="archive-card-static-content">
            @let eppDataGroupedByLocationIdValue = eppDataGroupedByLocationId();
            @let selectedEppStationIdValue = selectedEppStationId();
            @let eppStationNamesValue = eppStationNames();

            <!-- Dropdown-Reihe (Nebeneinander via Flexbox) -->
            <div class="archive-dropdown-select-row">
              <!-- EPP_STATION SELECTION -->
              <mat-form-field appearance="fill" class="archive-inline-select">
                <mat-select
                  [(value)]="selectedEppStationId"
                  (selectionChange)="
                    onEppStationChange(selectedEppStationIdValue)
                  ">
                  @for (
                    stationId of eppDataGroupedByLocationIdValue | key;
                    track $index
                  ) {
                    <mat-option id="eppStationSelect" [value]="stationId">
                      {{ eppStationNamesValue[stationId] }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <!-- EPP-TYPE SELECTION -->
              <mat-form-field appearance="fill" class="archive-inline-select">
                <mat-select [(value)]="selectedEppType">
                  @for (
                    productType of eppDataGroupedByLocationIdValue[
                      selectedEppStationIdValue
                    ] | key;
                    track $index
                  ) {
                    <mat-option id="eppTypeSelect" [value]="productType">
                      {{
                        'PRODUCT.EPP.RESOLUTION.TYPE.' +
                          (productType | split: ',' : 0 : 1) | translate
                      }}
                      {{
                        'PRODUCT.EPP.PARAMETERSET.SETS.' +
                          (productType | split: ',' : 1 : 2) | translate
                      }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- EPP PDF DOWNLOADS (Scrollbare Kiste im Glass-Look) -->
            <div class="archive-pdf-scroll-box">
              @for (
                singleEppData of eppDataGroupedByLocationIdValue[
                  selectedEppStationIdValue
                ][selectedEppType()];
                track $index
              ) {
                <a
                  mat-button
                  class="archive-pdf-download-link"
                  (click)="downloadPdf(singleEppData.path)">
                  <div class="pdf-link-content">
                    <fa-icon
                      [icon]="['far', 'file-pdf']"
                      class="pdf-file-icon"></fa-icon>
                    <span class="pdf-link-date">
                      {{
                        singleEppData.dtg
                          | datex
                            : 'DD.MM. HH:mm'
                            : undefined
                            : (langSignalValue | getLocaleFromLang)
                      }}
                      <small class="pdf-clock-lbl">{{
                        'DATETIME.CLOCK' | translate
                      }}</small>
                    </span>
                    <span class="pdf-link-divider">-</span>
                    <span class="pdf-link-station">{{
                      eppStationNamesValue[singleEppData.location]
                    }}</span>
                  </div>
                </a>
              }
            </div>
          </div>
        </mat-card>
      }

      @if (hasUserNLContent()) {
        <mat-card appearance="outlined" class="archive-card--small">
          <mat-card-header>
            <fa-icon
              mat-card-avatar
              [icon]="['far', 'file-chart-column']"
              size="2x"></fa-icon>
            <mat-card-title>
              <div class="archive-card-title">Jaaroverzicht</div>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <a
              mat-button
              color="primary"
              (click)="downloadDummyReport('yearly')">
              <p>
                <fa-icon [icon]="['far', 'file-pdf']"></fa-icon>
                &nbsp; Winteroverzicht 2023-2024
              </p>
            </a>
          </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="archive-card--small">
          <mat-card-header>
            <fa-icon
              mat-card-avatar
              [icon]="['far', 'file-chart-column']"
              size="2x"></fa-icon>
            <mat-card-title>
              <div class="archive-card-title">het Weekoverzicht</div>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <a
              mat-button
              color="primary"
              (click)="downloadDummyReport('weekly')">
              <p>
                <fa-icon [icon]="['far', 'file-pdf']"></fa-icon>
                &nbsp; Weekoverzicht Gelderland
              </p>
            </a>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>
